import { ListItem, ListItemButton, ListItemIcon, ListItemText, Icon, Typography } from "@mui/material";

/** Aligns the leading icon to the top of a multi-line row. */
const LIST_ITEM_SX = {
  ".MuiButtonBase-root": { alignItems: "flex-start" },
  ".MuiListItemIcon-root": { marginTop: "1%", minWidth: "34px" },
};

/**
 * One icon + title + description row, the shared option-list-dialog style used
 * by the Add to Calendar / Add to Group tray and the trial intent prompt. Wrap
 * these in a `<List>`.
 *
 * @param {object} props
 * @param {string} props.icon - Material Symbols glyph name.
 * @param {React.ReactNode} props.primary - Row title.
 * @param {React.ReactNode} props.secondary - Row description.
 * @param {string} [props.testId]
 * @param {() => void} props.onClick
 */
const DialogOptionRow = ({ icon, primary, secondary, testId, onClick }) => (
  <ListItem disablePadding sx={LIST_ITEM_SX}>
    <ListItemButton data-testid={testId} onClick={onClick}>
      <ListItemIcon>
        <Icon baseClassName="material-symbols-outlined" sx={{ color: "icon.primary", verticalAlign: "middle" }}>
          {icon}
        </Icon>
      </ListItemIcon>
      <ListItemText
        primary={<Typography variant="h5">{primary}</Typography>}
        secondary={<Typography variant="subtitle2" sx={{ color: "text.secondary" }}>{secondary}</Typography>}
      />
    </ListItemButton>
  </ListItem>
);

export default DialogOptionRow;
